// extracted by css-extract-rspack-plugin
export default {"actions":"OverviewShareSave-module__actions","pill":"OverviewShareSave-module__pill","heart":"OverviewShareSave-module__heart"};